import { PRODUCTS } from "@/src/constants/constants";
import type { Product } from "@/src/types";
import { ProductCard } from "@/src/pages/home/(sections)/products/ProductCard";

interface CollectionGridProps {
    onAddToCart: (product: Product) => void;
}

export function CollectionGrid({ onAddToCart }: CollectionGridProps) {
    return (
        <section className="max-w-7xl mx-auto px-6 py-24">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
                {PRODUCTS.map((product, idx) => (
                    <ProductCard
                        key={product.id}
                        product={product}
                        index={idx}
                        onAddToCart={onAddToCart}
                    />
                ))}
            </div>
        </section>
    );
}
